export const CYCLES_CHOOSE_TAB = 'CYCLES_CHOOSE_TAB'

export const chooseCyclesTab = ({ cycleId, tabId }) => ({
  type: CYCLES_CHOOSE_TAB,
  payload: {
    cycleId,
    tabId,
  },
})
